module.exports = __webpack_public_path__ + "static/media/waitListSecondScreen.12ba72ca.png";